<template>
  <div style="padding:10px;">
    <EditForm
      ref="editForm"
      :disabled="disabled"
      :amzFirstDemandCode="amzFirstDemandCode"
      :pageType="pageType"
    />
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import { mapActions } from 'vuex'

export default {
  name: 'ecom-awsBiz-skuFirstOrderReview-detail',
  components: { EditForm },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return ['detail'].includes(this.pageType)
    },
    amzFirstDemandCode() {
      return this.params.amzFirstDemandCode
    },
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
